import Link from "next/link";

const getRouteFragment = (member) =>
  member.is_organization_user ? "organizations" : "members";

const getUserName = (member) => {
  if (member.is_organization_user) {
    return member.organization_profile?.name || member.username;
  }

  return member.profile?.fullname || member.username;
};

const LinkToMemberDetails = ({ member }) => (
  <Link href={`/${getRouteFragment(member)}/${member.username}`}>
    {getUserName(member)}
  </Link>
);

export default LinkToMemberDetails;
